import { useState } from 'react'
import { Button, Steps, Divider } from 'antd'
import { useCreateMacroData } from './CreateMacroDataProvider'
import { setSteps } from './CreateMacroDataProvider/actions'
import GeneralConfig from './GeneralConfig'
import StepsConfig from './StepsConfig'
{ Step } = Steps

CreateMacro = ({ current, setCurrent }) ->

  <div style={{ height: '100%' }}>
    <Steps
      type="navigation"
      size="small"
      current={current}
      onChange={setCurrent}
    >
      <Step key="general-config" title="General" />
      <Step key="steps" title="Steps & Fields"/>
    </Steps>
    <Divider />

    { if current is 0
      <GeneralConfig />
    else
      <StepsConfig />
    }
  </div>

export default CreateMacro
